import React, { useContext, useState } from "react";
import { Col, Input, InputGroup, Row } from "reactstrap";
import { Picker } from "emoji-mart";
import { Btn, Image } from "../../../../AbstractElements";
import ChatAppContext from "../../../../_helper/Chat";
import { useSelector } from "react-redux";
import { setChatLoading, setChatMessages } from "../../../../utils/chatSlice";
import { useDispatch } from "react-redux";
import send_icon from "../../../../../src/assets/images/send_icon.png";
import { MdHeight } from "react-icons/md";
import { setUsers } from "../../../../utils/userSlice";

const SendChat = () => {
  const baseurl = useSelector((store) => store.baseUrl);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isSendDisabled, setIsSendDisabled] = useState(false);
  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const isgroup = useSelector((state) => state?.users?.isGroup);
  const dispatch = useDispatch();
  const selectedUserr = useSelector((state) => state?.users?.selectedUser);
  const addEmoji = (emoji) => {
    const text = `${messageInput}${emoji.native}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };
  const handleMessageChange = (message) => {
    setMessageInput(message);
  };

  const handleMessagePress = (e) => {
    sendMessage(messageInput);
  };

  const sendMessage = async (msg) => {
    if (!selectedUserr || !msg) {
      console.error("Cannot send message: Missing user or message");
      return;
    }
    setIsSendDisabled(true);

    // const isGroup = selectedUserr?.group_id; // Check if it's a group
    const formData = new FormData();
    // Append common fields
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));

    // Add necessary fields to FormData based on group or individual user
    if (isgroup) {
      formData.append("groupid", selectedUserr?.group_id);
      formData.append("memberid", selectedUserr?.member_id);
      formData.append("msg", msg); // Add the message to the FormData
    } else {
      const { employee_id: senderId, user_type: senderType } = userdetails;
      formData.append("sender_id", senderId);
      formData.append("sender_type", senderType);
      formData.append("receiver_id", selectedUserr?.employee_id);
      formData.append("receiver_type", selectedUserr?.user_type);
      formData.append("msg", msg); // Add the message to the FormData
    }

    // Determine the API endpoint dynamically
    const endpoint = isgroup
      ? `${baseurl}/common_api/send_group_message_chat/`
      : `${baseurl}/common_api/message_send/`;

    try {
      // Make the POST request
      const response = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      const { STATUS, MESSAGE } = result[0] || {};

      if (STATUS === "SUCCESS") {
        setMessageInput(""); // Clear the input field after successful send
       await fetchChatHistory(selectedUserr, userdetails); // Refresh chat history
       await fetchEmployeeList()
      } else {
        console.error("Failed to send message:", MESSAGE);
      }
    } catch (error) {
      console.error("Error sending message:", error.message);
    } finally {
      setIsSendDisabled(false);
    }
  };

  const fetchEmployeeList = async () => {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("user_id", userdetails?.employee_id);
      formData.append("get_group", "Y");
      formData.append("user_type", userdetails?.user_type);
  
      try {
        const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
          method: "POST",
          body: formData,
        });
        const result = await response.json();
  
        if (result[0]?.STATUS == "SUCCESS") {
          const employeeArr = result[0]?.DATA?.employee_arr;
          dispatch(setUsers(employeeArr));
          // dispatch(selectUser(employeeArr[0]));
        } else {
          console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
          dispatch(setUsers([]));
          // dispatch(selectUser({}));
        }
      } catch (error) {
        console.error("Error fetching employee list:", error.message);
        dispatch(setUsers([]));
        // dispatch(selectUser({}));
      }
    };

  // Centralized Fetch Function
  const fetchChatHistory = async (selectedUserr, userdetails) => {
    if (!selectedUserr) return; // Exit if no user is selected

    // dispatch(setChatMessages([])); // Clear previous messages
    // dispatch(setChatLoading({ isLoading: true })); // Show loading indicator

    try {
      let apiEndpoint = "";
      const formData = new FormData();

      // Append common fields
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));

      // Determine API endpoint and specific fields
      if (isgroup) {
        // Group chat case
        apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
        formData.append("groupid", selectedUserr?.group_id);
        formData.append("memberid", selectedUserr?.member_id);
      } else {
        // Individual chat case
        apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
        const { employee_id: senderId, user_type: senderType } = userdetails;
        formData.append("receiver_id", selectedUserr.employee_id);
        formData.append("receiver_type", selectedUserr.user_type);
        formData.append("sender_id", senderId);
        formData.append("sender_type", senderType);
      }

      // Fetch data from the API
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      const { STATUS, DATA } = result[0] || {};

      if (STATUS == "SUCCESS") {
        // Sort and dispatch messages
        const sortedMessages = DATA?.sort((a, b) => a.order_no - b.order_no);
        dispatch(setChatMessages(sortedMessages));
      } else {
        console.error("Failed to fetch chat history:", STATUS);
        dispatch(setChatMessages([]));
      }
    } catch (error) {
      console.error("Error fetching chat history:", error.message);
      dispatch(setChatMessages([]));
    } finally {
      // dispatch(setChatLoading({ isLoading: false })); // Reset loading indicator
    }
  };

  return (
    <div className="chat-message clearfix">
      <Row>
        {/* <div>
          {showEmojiPicker ? (
            <Picker set="apple" emojiSize={30} onSelect={addEmoji} />
          ) : null}
        </div> */}
        <Col xl="12" className="d-flex align-items-center column-gap-2">
          {/* <div className="smiley-box bg-primary timesheet-smiley-box">
            <div className="picker" onClick={() => toggleEmojiPicker()}>
              <Image
                attrImage={{
                  src: `${require("../../../../assets/images/smiley.png")}`,
                  alt: "",
                }}
              />
            </div>
          </div> */}
          <InputGroup className="text-box timesheet-text-box">
            <Input
              type="text"
              className="form-control input-txt-bx"
              placeholder="Type a message..."
              value={messageInput}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  // Check if the pressed key is Enter
                  e.preventDefault(); // Prevent the default action (optional)
                  handleMessagePress(); // Call the handleMessagePress function
                }
              }}
              onChange={(e) => handleMessageChange(e.target.value)}
            />
          </InputGroup>
          {/* <Btn
              attrBtn={{
                color: "primary",
                onClick: () => handleMessagePress(),
                // disabled: isSendDisabled, // Add this line with your condition
                className: "send-btn",
              }}
            >
              Send
            </Btn> */}
          <div>
            <Image
              attrImage={{
                src: `${send_icon}`,
                alt: "send_icon",
                style: { cursor: "pointer" },
                onClick: () => handleMessagePress(),
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SendChat;
